import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const Tops = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.tops.title')}
      contentType="tops"
      description={t('page.tops.desc')}
      outputLabel={t('page.tops.output')}
    />
  );
};
